define.alias("shared/components/shared/ui/social-profile-switcher/item", "media/components/shared/ui/social-profile-switcher/item");